export class WorkloadOperatorsManager {

    constructor(private containerElement: JQuery) { }

    private workloadStartDateInput : JQuery<HTMLElement>;
    private workloadEndDateInput : JQuery<HTMLElement>;
    private assignedOperatorsContainer : JQuery<HTMLElement>;

    //private addUserModalHelper : ModalHelper;
    // private addManualProjectManager : AddManualProjectManager;

    public initialize() {
        var self = this;

        self.workloadStartDateInput = self.containerElement.find('#workload-start-date-input'); 
        self.workloadEndDateInput = self.containerElement.find('#workload-end-date-input'); 
        self.assignedOperatorsContainer = self.containerElement.find('#assigned-operators-container'); 

        self.workloadStartDateInput.off('change').on('change', () => {
            self.loadAssignedOperators();
        })       
        
        self.workloadEndDateInput.off('change').on('change', () => {
            self.loadAssignedOperators();
        })

        self.loadAssignedOperators();
        
    }

    private loadAssignedOperators() {
        var self = this;
        var startDate = self.workloadStartDateInput.val();
        var endDate = self.workloadEndDateInput.val();

        self.assignedOperatorsContainer.load(`?workloadStartDate=${startDate}&workloadEndDate=${endDate}&handler=AssignedOperatorsForDate`, () => {

        })
    }
}